export var TrackEvent;
(function (TrackEvent) {
    TrackEvent["ONGOING"] = "ONGOING";
    TrackEvent["END"] = "END";
    TrackEvent["START"] = "START";
})(TrackEvent || (TrackEvent = {}));
export const encodeTrackEvent = {
    ONGOING: 0,
    END: 1,
    START: 2,
};
export const decodeTrackEvent = {
    0: TrackEvent.ONGOING,
    1: TrackEvent.END,
    2: TrackEvent.START,
};
export var ObjectType;
(function (ObjectType) {
    ObjectType["OBJECT_UNKNOWN"] = "OBJECT_UNKNOWN";
    ObjectType["OBJECT_FACE"] = "OBJECT_FACE";
    ObjectType["OBJECT_PEDESTRIAN"] = "OBJECT_PEDESTRIAN";
    ObjectType["OBJECT_AUTOMOBILE"] = "OBJECT_AUTOMOBILE";
    ObjectType["OBJECT_CYCLIST"] = "OBJECT_CYCLIST";
    ObjectType["OBJECT_HUMAN_POWERED_VEHICLE"] = "OBJECT_HUMAN_POWERED_VEHICLE";
    ObjectType["OBJECT_CROWD"] = "OBJECT_CROWD";
    ObjectType["OBJECT_SCENARIO"] = "OBJECT_SCENARIO";
    ObjectType["OBJECT_ALGO"] = "OBJECT_ALGO";
    ObjectType["OBJECT_EVENT"] = "OBJECT_EVENT";
})(ObjectType || (ObjectType = {}));
export const encodeObjectType = {
    OBJECT_UNKNOWN: 0,
    OBJECT_FACE: 1,
    OBJECT_PEDESTRIAN: 2,
    OBJECT_AUTOMOBILE: 3,
    OBJECT_CYCLIST: 4,
    OBJECT_HUMAN_POWERED_VEHICLE: 5,
    OBJECT_CROWD: 6,
    OBJECT_SCENARIO: 7,
    OBJECT_ALGO: 8,
    OBJECT_EVENT: 11,
};
export const decodeObjectType = {
    0: ObjectType.OBJECT_UNKNOWN,
    1: ObjectType.OBJECT_FACE,
    2: ObjectType.OBJECT_PEDESTRIAN,
    3: ObjectType.OBJECT_AUTOMOBILE,
    4: ObjectType.OBJECT_CYCLIST,
    5: ObjectType.OBJECT_HUMAN_POWERED_VEHICLE,
    6: ObjectType.OBJECT_CROWD,
    7: ObjectType.OBJECT_SCENARIO,
    8: ObjectType.OBJECT_ALGO,
    11: ObjectType.OBJECT_EVENT,
};
export var EventType;
(function (EventType) {
    EventType["EVENT_UNKNOWN"] = "EVENT_UNKNOWN";
    EventType["EVENT_PEDESTRIAN_STAY"] = "EVENT_PEDESTRIAN_STAY";
    EventType["EVENT_PEDESTRIAN_HOVER"] = "EVENT_PEDESTRIAN_HOVER";
    EventType["EVENT_PEDESTRIAN_CROSS_LINE"] = "EVENT_PEDESTRIAN_CROSS_LINE";
    EventType["EVENT_PEDESTRIAN_INVADE"] = "EVENT_PEDESTRIAN_INVADE";
    EventType["EVENT_VEHICLE_PARK"] = "EVENT_VEHICLE_PARK";
    EventType["EVENT_CROWD_DENSITY"] = "EVENT_CROWD_DENSITY";
    EventType["EVENT_CROWD_STRAND"] = "EVENT_CROWD_STRAND";
    EventType["EVENT_CROWD_RETROGRADE"] = "EVENT_CROWD_RETROGRADE";
    EventType["EVENT_CROWD_CONGREGATE"] = "EVENT_CROWD_CONGREGATE";
    EventType["EVENT_CROWD_SCATTER"] = "EVENT_CROWD_SCATTER";
    EventType["EVENT_CROWD_SPEED"] = "EVENT_CROWD_SPEED";
    EventType["EVENT_CROWD_SOCIAL_DISTANCE"] = "EVENT_CROWD_SOCIAL_DISTANCE";
})(EventType || (EventType = {}));
export const encodeEventType = {
    EVENT_UNKNOWN: 0,
    EVENT_PEDESTRIAN_STAY: 1,
    EVENT_PEDESTRIAN_HOVER: 2,
    EVENT_PEDESTRIAN_CROSS_LINE: 3,
    EVENT_PEDESTRIAN_INVADE: 4,
    EVENT_VEHICLE_PARK: 5,
    EVENT_CROWD_DENSITY: 50,
    EVENT_CROWD_STRAND: 51,
    EVENT_CROWD_RETROGRADE: 52,
    EVENT_CROWD_CONGREGATE: 53,
    EVENT_CROWD_SCATTER: 54,
    EVENT_CROWD_SPEED: 55,
    EVENT_CROWD_SOCIAL_DISTANCE: 56,
};
export const decodeEventType = {
    0: EventType.EVENT_UNKNOWN,
    1: EventType.EVENT_PEDESTRIAN_STAY,
    2: EventType.EVENT_PEDESTRIAN_HOVER,
    3: EventType.EVENT_PEDESTRIAN_CROSS_LINE,
    4: EventType.EVENT_PEDESTRIAN_INVADE,
    5: EventType.EVENT_VEHICLE_PARK,
    50: EventType.EVENT_CROWD_DENSITY,
    51: EventType.EVENT_CROWD_STRAND,
    52: EventType.EVENT_CROWD_RETROGRADE,
    53: EventType.EVENT_CROWD_CONGREGATE,
    54: EventType.EVENT_CROWD_SCATTER,
    55: EventType.EVENT_CROWD_SPEED,
    56: EventType.EVENT_CROWD_SOCIAL_DISTANCE,
};
export var EventStatus;
(function (EventStatus) {
    EventStatus["STATUS_UNKNOWN"] = "STATUS_UNKNOWN";
    EventStatus["STATUS_START"] = "STATUS_START";
    EventStatus["STATUS_CONTINUE"] = "STATUS_CONTINUE";
    EventStatus["STATUS_STOP"] = "STATUS_STOP";
})(EventStatus || (EventStatus = {}));
export const encodeEventStatus = {
    STATUS_UNKNOWN: 0,
    STATUS_START: 1,
    STATUS_CONTINUE: 2,
    STATUS_STOP: 3,
};
export const decodeEventStatus = {
    0: EventStatus.STATUS_UNKNOWN,
    1: EventStatus.STATUS_START,
    2: EventStatus.STATUS_CONTINUE,
    3: EventStatus.STATUS_STOP,
};
export var ScenarioType;
(function (ScenarioType) {
    ScenarioType["ST_UNKNOWN"] = "ST_UNKNOWN";
    ScenarioType["ST_STALL"] = "ST_STALL";
    ScenarioType["ST_FIRE"] = "ST_FIRE";
    ScenarioType["ST_SLOGAN"] = "ST_SLOGAN";
    ScenarioType["ST_LANDSCAPE_LAMP"] = "ST_LANDSCAPE_LAMP";
    ScenarioType["ST_CLUTTER"] = "ST_CLUTTER";
    ScenarioType["ST_ROAD_CLEAN"] = "ST_ROAD_CLEAN";
    ScenarioType["ST_SOIL"] = "ST_SOIL";
    ScenarioType["ST_GARBAGE"] = "ST_GARBAGE";
    ScenarioType["ST_SHARED_BICYCLE"] = "ST_SHARED_BICYCLE";
    ScenarioType["ST_SHARED_BICYCLE_MISORDER"] = "ST_SHARED_BICYCLE_MISORDER";
})(ScenarioType || (ScenarioType = {}));
export const encodeScenarioType = {
    ST_UNKNOWN: 0,
    ST_STALL: 1,
    ST_FIRE: 2,
    ST_SLOGAN: 3,
    ST_LANDSCAPE_LAMP: 4,
    ST_CLUTTER: 5,
    ST_ROAD_CLEAN: 6,
    ST_SOIL: 7,
    ST_GARBAGE: 8,
    ST_SHARED_BICYCLE: 9,
    ST_SHARED_BICYCLE_MISORDER: 10,
};
export const decodeScenarioType = {
    0: ScenarioType.ST_UNKNOWN,
    1: ScenarioType.ST_STALL,
    2: ScenarioType.ST_FIRE,
    3: ScenarioType.ST_SLOGAN,
    4: ScenarioType.ST_LANDSCAPE_LAMP,
    5: ScenarioType.ST_CLUTTER,
    6: ScenarioType.ST_ROAD_CLEAN,
    7: ScenarioType.ST_SOIL,
    8: ScenarioType.ST_GARBAGE,
    9: ScenarioType.ST_SHARED_BICYCLE,
    10: ScenarioType.ST_SHARED_BICYCLE_MISORDER,
};
export var CrowdDirection;
(function (CrowdDirection) {
    CrowdDirection["CROWD_UNKNOWN"] = "CROWD_UNKNOWN";
    CrowdDirection["CROWD_CONCENTRIC"] = "CROWD_CONCENTRIC";
    CrowdDirection["CROWD_SAME_DIRECTION"] = "CROWD_SAME_DIRECTION";
    CrowdDirection["CROWD_LEFT"] = "CROWD_LEFT";
    CrowdDirection["CROWD_RIGHT"] = "CROWD_RIGHT";
    CrowdDirection["CROWD_AWAY"] = "CROWD_AWAY";
    CrowdDirection["CROWD_TOWARD"] = "CROWD_TOWARD";
})(CrowdDirection || (CrowdDirection = {}));
export const encodeCrowdDirection = {
    CROWD_UNKNOWN: 0,
    CROWD_CONCENTRIC: 1,
    CROWD_SAME_DIRECTION: 2,
    CROWD_LEFT: 3,
    CROWD_RIGHT: 4,
    CROWD_AWAY: 5,
    CROWD_TOWARD: 6,
};
export const decodeCrowdDirection = {
    0: CrowdDirection.CROWD_UNKNOWN,
    1: CrowdDirection.CROWD_CONCENTRIC,
    2: CrowdDirection.CROWD_SAME_DIRECTION,
    3: CrowdDirection.CROWD_LEFT,
    4: CrowdDirection.CROWD_RIGHT,
    5: CrowdDirection.CROWD_AWAY,
    6: CrowdDirection.CROWD_TOWARD,
};
export function encodeVertex(message) {
    const bb = popByteBuffer();
    _encodeVertex(message, bb);
    return toUint8Array(bb);
}
function _encodeVertex(message, bb) {
    // optional int32 x = 1;
    const $x = message.x;
    if ($x !== undefined) {
        writeVarint32(bb, 8);
        writeVarint64(bb, intToLong($x));
    }
    // optional int32 y = 2;
    const $y = message.y;
    if ($y !== undefined) {
        writeVarint32(bb, 16);
        writeVarint64(bb, intToLong($y));
    }
}
export function decodeVertex(binary) {
    return _decodeVertex(wrapByteBuffer(binary));
}
function _decodeVertex(bb) {
    const message = {};
    end_of_message: while (!isAtEnd(bb)) {
        const tag = readVarint32(bb);
        switch (tag >>> 3) {
            case 0:
                break end_of_message;
            // optional int32 x = 1;
            case 1: {
                message.x = readVarint32(bb);
                break;
            }
            // optional int32 y = 2;
            case 2: {
                message.y = readVarint32(bb);
                break;
            }
            default:
                skipUnknownField(bb, tag & 7);
        }
    }
    return message;
}
export function encodeBoundingPoly(message) {
    const bb = popByteBuffer();
    _encodeBoundingPoly(message, bb);
    return toUint8Array(bb);
}
function _encodeBoundingPoly(message, bb) {
    // repeated Vertex vertices = 1;
    const array$vertices = message.vertices;
    if (array$vertices !== undefined) {
        for (const value of array$vertices) {
            writeVarint32(bb, 10);
            const nested = popByteBuffer();
            _encodeVertex(value, nested);
            writeVarint32(bb, nested.limit);
            writeByteBuffer(bb, nested);
            pushByteBuffer(nested);
        }
    }
}
export function decodeBoundingPoly(binary) {
    return _decodeBoundingPoly(wrapByteBuffer(binary));
}
function _decodeBoundingPoly(bb) {
    const message = {};
    end_of_message: while (!isAtEnd(bb)) {
        const tag = readVarint32(bb);
        switch (tag >>> 3) {
            case 0:
                break end_of_message;
            // repeated Vertex vertices = 1;
            case 1: {
                const limit = pushTemporaryLength(bb);
                const values = message.vertices || (message.vertices = []);
                values.push(_decodeVertex(bb));
                bb.limit = limit;
                break;
            }
            default:
                skipUnknownField(bb, tag & 7);
        }
    }
    return message;
}
export function encodeLineVertex(message) {
    const bb = popByteBuffer();
    _encodeLineVertex(message, bb);
    return toUint8Array(bb);
}
function _encodeLineVertex(message, bb) {
    // repeated Vertex vertices = 1;
    const array$vertices = message.vertices;
    if (array$vertices !== undefined) {
        for (const value of array$vertices) {
            writeVarint32(bb, 10);
            const nested = popByteBuffer();
            _encodeVertex(value, nested);
            writeVarint32(bb, nested.limit);
            writeByteBuffer(bb, nested);
            pushByteBuffer(nested);
        }
    }
}
export function decodeLineVertex(binary) {
    return _decodeLineVertex(wrapByteBuffer(binary));
}
function _decodeLineVertex(bb) {
    const message = {};
    end_of_message: while (!isAtEnd(bb)) {
        const tag = readVarint32(bb);
        switch (tag >>> 3) {
            case 0:
                break end_of_message;
            // repeated Vertex vertices = 1;
            case 1: {
                const limit = pushTemporaryLength(bb);
                const values = message.vertices || (message.vertices = []);
                values.push(_decodeVertex(bb));
                bb.limit = limit;
                break;
            }
            default:
                skipUnknownField(bb, tag & 7);
        }
    }
    return message;
}
export function encodeAngle(message) {
    const bb = popByteBuffer();
    _encodeAngle(message, bb);
    return toUint8Array(bb);
}
function _encodeAngle(message, bb) {
    // optional float yaw = 1;
    const $yaw = message.yaw;
    if ($yaw !== undefined) {
        writeVarint32(bb, 13);
        writeFloat(bb, $yaw);
    }
    // optional float pitch = 2;
    const $pitch = message.pitch;
    if ($pitch !== undefined) {
        writeVarint32(bb, 21);
        writeFloat(bb, $pitch);
    }
    // optional float roll = 3;
    const $roll = message.roll;
    if ($roll !== undefined) {
        writeVarint32(bb, 29);
        writeFloat(bb, $roll);
    }
}
export function decodeAngle(binary) {
    return _decodeAngle(wrapByteBuffer(binary));
}
function _decodeAngle(bb) {
    const message = {};
    end_of_message: while (!isAtEnd(bb)) {
        const tag = readVarint32(bb);
        switch (tag >>> 3) {
            case 0:
                break end_of_message;
            // optional float yaw = 1;
            case 1: {
                message.yaw = readFloat(bb);
                break;
            }
            // optional float pitch = 2;
            case 2: {
                message.pitch = readFloat(bb);
                break;
            }
            // optional float roll = 3;
            case 3: {
                message.roll = readFloat(bb);
                break;
            }
            default:
                skipUnknownField(bb, tag & 7);
        }
    }
    return message;
}
export function encodeSize(message) {
    const bb = popByteBuffer();
    _encodeSize(message, bb);
    return toUint8Array(bb);
}
function _encodeSize(message, bb) {
    // optional int32 width = 1;
    const $width = message.width;
    if ($width !== undefined) {
        writeVarint32(bb, 8);
        writeVarint64(bb, intToLong($width));
    }
    // optional int32 height = 2;
    const $height = message.height;
    if ($height !== undefined) {
        writeVarint32(bb, 16);
        writeVarint64(bb, intToLong($height));
    }
}
export function decodeSize(binary) {
    return _decodeSize(wrapByteBuffer(binary));
}
function _decodeSize(bb) {
    const message = {};
    end_of_message: while (!isAtEnd(bb)) {
        const tag = readVarint32(bb);
        switch (tag >>> 3) {
            case 0:
                break end_of_message;
            // optional int32 width = 1;
            case 1: {
                message.width = readVarint32(bb);
                break;
            }
            // optional int32 height = 2;
            case 2: {
                message.height = readVarint32(bb);
                break;
            }
            default:
                skipUnknownField(bb, tag & 7);
        }
    }
    return message;
}
export function encodeVector(message) {
    const bb = popByteBuffer();
    _encodeVector(message, bb);
    return toUint8Array(bb);
}
function _encodeVector(message, bb) {
    // optional float x = 1;
    const $x = message.x;
    if ($x !== undefined) {
        writeVarint32(bb, 13);
        writeFloat(bb, $x);
    }
    // optional float y = 2;
    const $y = message.y;
    if ($y !== undefined) {
        writeVarint32(bb, 21);
        writeFloat(bb, $y);
    }
}
export function decodeVector(binary) {
    return _decodeVector(wrapByteBuffer(binary));
}
function _decodeVector(bb) {
    const message = {};
    end_of_message: while (!isAtEnd(bb)) {
        const tag = readVarint32(bb);
        switch (tag >>> 3) {
            case 0:
                break end_of_message;
            // optional float x = 1;
            case 1: {
                message.x = readFloat(bb);
                break;
            }
            // optional float y = 2;
            case 2: {
                message.y = readFloat(bb);
                break;
            }
            default:
                skipUnknownField(bb, tag & 7);
        }
    }
    return message;
}
export function encodeObjectAssociation(message) {
    const bb = popByteBuffer();
    _encodeObjectAssociation(message, bb);
    return toUint8Array(bb);
}
function _encodeObjectAssociation(message, bb) {
    // optional ObjectType type = 1;
    const $type = message.type;
    if ($type !== undefined) {
        writeVarint32(bb, 8);
        writeVarint32(bb, encodeObjectType[$type]);
    }
    // optional string object_id = 2;
    const $object_id = message.object_id;
    if ($object_id !== undefined) {
        writeVarint32(bb, 18);
        writeString(bb, $object_id);
    }
    // optional string association_type = 3;
    const $association_type = message.association_type;
    if ($association_type !== undefined) {
        writeVarint32(bb, 26);
        writeString(bb, $association_type);
    }
}
export function decodeObjectAssociation(binary) {
    return _decodeObjectAssociation(wrapByteBuffer(binary));
}
function _decodeObjectAssociation(bb) {
    const message = {};
    end_of_message: while (!isAtEnd(bb)) {
        const tag = readVarint32(bb);
        switch (tag >>> 3) {
            case 0:
                break end_of_message;
            // optional ObjectType type = 1;
            case 1: {
                message.type = decodeObjectType[readVarint32(bb)];
                break;
            }
            // optional string object_id = 2;
            case 2: {
                message.object_id = readString(bb, readVarint32(bb));
                break;
            }
            // optional string association_type = 3;
            case 3: {
                message.association_type = readString(bb, readVarint32(bb));
                break;
            }
            default:
                skipUnknownField(bb, tag & 7);
        }
    }
    return message;
}
export function encodeEventRule(message) {
    const bb = popByteBuffer();
    _encodeEventRule(message, bb);
    return toUint8Array(bb);
}
function _encodeEventRule(message, bb) {
    // optional EventType type = 1;
    const $type = message.type;
    if ($type !== undefined) {
        writeVarint32(bb, 8);
        writeVarint32(bb, encodeEventType[$type]);
    }
    // optional string rule_id = 2;
    const $rule_id = message.rule_id;
    if ($rule_id !== undefined) {
        writeVarint32(bb, 18);
        writeString(bb, $rule_id);
    }
    // optional BoundingPoly roi = 3;
    const $roi = message.roi;
    if ($roi !== undefined) {
        writeVarint32(bb, 26);
        const nested = popByteBuffer();
        _encodeBoundingPoly($roi, nested);
        writeVarint32(bb, nested.limit);
        writeByteBuffer(bb, nested);
        pushByteBuffer(nested);
    }
    // optional int32 duration_ms = 4;
    const $duration_ms = message.duration_ms;
    if ($duration_ms !== undefined) {
        writeVarint32(bb, 32);
        writeVarint64(bb, intToLong($duration_ms));
    }
    // optional Vector direction = 5;
    const $direction = message.direction;
    if ($direction !== undefined) {
        writeVarint32(bb, 42);
        const nested = popByteBuffer();
        _encodeVector($direction, nested);
        writeVarint32(bb, nested.limit);
        writeByteBuffer(bb, nested);
        pushByteBuffer(nested);
    }
}
export function decodeEventRule(binary) {
    return _decodeEventRule(wrapByteBuffer(binary));
}
function _decodeEventRule(bb) {
    const message = {};
    end_of_message: while (!isAtEnd(bb)) {
        const tag = readVarint32(bb);
        switch (tag >>> 3) {
            case 0:
                break end_of_message;
            // optional EventType type = 1;
            case 1: {
                message.type = decodeEventType[readVarint32(bb)];
                break;
            }
            // optional string rule_id = 2;
            case 2: {
                message.rule_id = readString(bb, readVarint32(bb));
                break;
            }
            // optional BoundingPoly roi = 3;
            case 3: {
                const limit = pushTemporaryLength(bb);
                message.roi = _decodeBoundingPoly(bb);
                bb.limit = limit;
                break;
            }
            // optional int32 duration_ms = 4;
            case 4: {
                message.duration_ms = readVarint32(bb);
                break;
            }
            // optional Vector direction = 5;
            case 5: {
                const limit = pushTemporaryLength(bb);
                message.direction = _decodeVector(bb);
                bb.limit = limit;
                break;
            }
            default:
                skipUnknownField(bb, tag & 7);
        }
    }
    return message;
}
export function encodeEvent(message) {
    const bb = popByteBuffer();
    _encodeEvent(message, bb);
    return toUint8Array(bb);
}
function _encodeEvent(message, bb) {
    // optional string rule_id = 1;
    const $rule_id = message.rule_id;
    if ($rule_id !== undefined) {
        writeVarint32(bb, 10);
        writeString(bb, $rule_id);
    }
    // optional EventStatus status = 2;
    const $status = message.status;
    if ($status !== undefined) {
        writeVarint32(bb, 16);
        writeVarint32(bb, encodeEventStatus[$status]);
    }
}
export function decodeEvent(binary) {
    return _decodeEvent(wrapByteBuffer(binary));
}
function _decodeEvent(bb) {
    const message = {};
    end_of_message: while (!isAtEnd(bb)) {
        const tag = readVarint32(bb);
        switch (tag >>> 3) {
            case 0:
                break end_of_message;
            // optional string rule_id = 1;
            case 1: {
                message.rule_id = readString(bb, readVarint32(bb));
                break;
            }
            // optional EventStatus status = 2;
            case 2: {
                message.status = decodeEventStatus[readVarint32(bb)];
                break;
            }
            default:
                skipUnknownField(bb, tag & 7);
        }
    }
    return message;
}
export function encodeEventObject(message) {
    const bb = popByteBuffer();
    _encodeEventObject(message, bb);
    return toUint8Array(bb);
}
function _encodeEventObject(message, bb) {
    // optional string rule_id = 1;
    const $rule_id = message.rule_id;
    if ($rule_id !== undefined) {
        writeVarint32(bb, 10);
        writeString(bb, $rule_id);
    }
    // optional string event_type = 2;
    const $event_type = message.event_type;
    if ($event_type !== undefined) {
        writeVarint32(bb, 18);
        writeString(bb, $event_type);
    }
}
export function decodeEventObject(binary) {
    return _decodeEventObject(wrapByteBuffer(binary));
}
function _decodeEventObject(bb) {
    const message = {};
    end_of_message: while (!isAtEnd(bb)) {
        const tag = readVarint32(bb);
        switch (tag >>> 3) {
            case 0:
                break end_of_message;
            // optional string rule_id = 1;
            case 1: {
                message.rule_id = readString(bb, readVarint32(bb));
                break;
            }
            // optional string event_type = 2;
            case 2: {
                message.event_type = readString(bb, readVarint32(bb));
                break;
            }
            default:
                skipUnknownField(bb, tag & 7);
        }
    }
    return message;
}
export function encodePreviewObject(message) {
    const bb = popByteBuffer();
    _encodePreviewObject(message, bb);
    return toUint8Array(bb);
}
function _encodePreviewObject(message, bb) {
    // optional ObjectType object_type = 1;
    const $object_type = message.object_type;
    if ($object_type !== undefined) {
        writeVarint32(bb, 8);
        writeVarint32(bb, encodeObjectType[$object_type]);
    }
    // optional int64 track_id = 2;
    const $track_id = message.track_id;
    if ($track_id !== undefined) {
        writeVarint32(bb, 16);
        writeVarint64(bb, $track_id);
    }
    // optional string object_id = 8;
    const $object_id = message.object_id;
    if ($object_id !== undefined) {
        writeVarint32(bb, 66);
        writeString(bb, $object_id);
    }
    // optional BoundingPoly bounding = 3;
    const $bounding = message.bounding;
    if ($bounding !== undefined) {
        writeVarint32(bb, 26);
        const nested = popByteBuffer();
        _encodeBoundingPoly($bounding, nested);
        writeVarint32(bb, nested.limit);
        writeByteBuffer(bb, nested);
        pushByteBuffer(nested);
    }
    // optional float quality = 4;
    const $quality = message.quality;
    if ($quality !== undefined) {
        writeVarint32(bb, 37);
        writeFloat(bb, $quality);
    }
    // optional Angle angle = 5;
    const $angle = message.angle;
    if ($angle !== undefined) {
        writeVarint32(bb, 42);
        const nested = popByteBuffer();
        _encodeAngle($angle, nested);
        writeVarint32(bb, nested.limit);
        writeByteBuffer(bb, nested);
        pushByteBuffer(nested);
    }
    // optional map<string, string> attributes = 6;
    const map$attributes = message.attributes;
    if (map$attributes !== undefined) {
        for (const key in map$attributes) {
            const nested = popByteBuffer();
            const value = map$attributes[key];
            writeVarint32(nested, 10);
            writeString(nested, key);
            writeVarint32(nested, 18);
            writeString(nested, value);
            writeVarint32(bb, 50);
            writeVarint32(bb, nested.offset);
            writeByteBuffer(bb, nested);
            pushByteBuffer(nested);
        }
    }
    // optional TrackEvent track_event = 9;
    const $track_event = message.track_event;
    if ($track_event !== undefined) {
        writeVarint32(bb, 72);
        writeVarint32(bb, encodeTrackEvent[$track_event]);
    }
    // repeated ObjectAssociation associations = 12;
    const array$associations = message.associations;
    if (array$associations !== undefined) {
        for (const value of array$associations) {
            writeVarint32(bb, 98);
            const nested = popByteBuffer();
            _encodeObjectAssociation(value, nested);
            writeVarint32(bb, nested.limit);
            writeByteBuffer(bb, nested);
            pushByteBuffer(nested);
        }
    }
    // repeated Event events = 7;
    const array$events = message.events;
    if (array$events !== undefined) {
        for (const value of array$events) {
            writeVarint32(bb, 58);
            const nested = popByteBuffer();
            _encodeEvent(value, nested);
            writeVarint32(bb, nested.limit);
            writeByteBuffer(bb, nested);
            pushByteBuffer(nested);
        }
    }
    // optional CrowdObject crowd = 20;
    const $crowd = message.crowd;
    if ($crowd !== undefined) {
        writeVarint32(bb, 162);
        const nested = popByteBuffer();
        _encodeCrowdObject($crowd, nested);
        writeVarint32(bb, nested.limit);
        writeByteBuffer(bb, nested);
        pushByteBuffer(nested);
    }
    // optional ScenarioObject scenario = 21;
    const $scenario = message.scenario;
    if ($scenario !== undefined) {
        writeVarint32(bb, 170);
        const nested = popByteBuffer();
        _encodeScenarioObject($scenario, nested);
        writeVarint32(bb, nested.limit);
        writeByteBuffer(bb, nested);
        pushByteBuffer(nested);
    }
    // optional AlgoObject algo = 22;
    const $algo = message.algo;
    if ($algo !== undefined) {
        writeVarint32(bb, 178);
        const nested = popByteBuffer();
        _encodeAlgoObject($algo, nested);
        writeVarint32(bb, nested.limit);
        writeByteBuffer(bb, nested);
        pushByteBuffer(nested);
    }
    // optional EventObject event = 23;
    const $event = message.event;
    if ($event !== undefined) {
        writeVarint32(bb, 186);
        const nested = popByteBuffer();
        _encodeEventObject($event, nested);
        writeVarint32(bb, nested.limit);
        writeByteBuffer(bb, nested);
        pushByteBuffer(nested);
    }
}
export function decodePreviewObject(binary) {
    return _decodePreviewObject(wrapByteBuffer(binary));
}
function _decodePreviewObject(bb) {
    const message = {};
    end_of_message: while (!isAtEnd(bb)) {
        const tag = readVarint32(bb);
        switch (tag >>> 3) {
            case 0:
                break end_of_message;
            // optional ObjectType object_type = 1;
            case 1: {
                message.object_type = decodeObjectType[readVarint32(bb)];
                break;
            }
            // optional int64 track_id = 2;
            case 2: {
                message.track_id = readVarint64(bb, /* unsigned */ false);
                break;
            }
            // optional string object_id = 8;
            case 8: {
                message.object_id = readString(bb, readVarint32(bb));
                break;
            }
            // optional BoundingPoly bounding = 3;
            case 3: {
                const limit = pushTemporaryLength(bb);
                message.bounding = _decodeBoundingPoly(bb);
                bb.limit = limit;
                break;
            }
            // optional float quality = 4;
            case 4: {
                message.quality = readFloat(bb);
                break;
            }
            // optional Angle angle = 5;
            case 5: {
                const limit = pushTemporaryLength(bb);
                message.angle = _decodeAngle(bb);
                bb.limit = limit;
                break;
            }
            // optional map<string, string> attributes = 6;
            case 6: {
                const values = message.attributes || (message.attributes = {});
                const outerLimit = pushTemporaryLength(bb);
                let key;
                let value;
                end_of_entry: while (!isAtEnd(bb)) {
                    const tag = readVarint32(bb);
                    switch (tag >>> 3) {
                        case 0:
                            break end_of_entry;
                        case 1: {
                            key = readString(bb, readVarint32(bb));
                            break;
                        }
                        case 2: {
                            value = readString(bb, readVarint32(bb));
                            break;
                        }
                        default:
                            skipUnknownField(bb, tag & 7);
                    }
                }
                if (key === undefined || value === undefined) {
                    throw new Error('Invalid data for map: attributes');
                }
                values[key] = value;
                bb.limit = outerLimit;
                break;
            }
            // optional TrackEvent track_event = 9;
            case 9: {
                message.track_event = decodeTrackEvent[readVarint32(bb)];
                break;
            }
            // repeated ObjectAssociation associations = 12;
            case 12: {
                const limit = pushTemporaryLength(bb);
                const values = message.associations || (message.associations = []);
                values.push(_decodeObjectAssociation(bb));
                bb.limit = limit;
                break;
            }
            // repeated Event events = 7;
            case 7: {
                const limit = pushTemporaryLength(bb);
                const values = message.events || (message.events = []);
                values.push(_decodeEvent(bb));
                bb.limit = limit;
                break;
            }
            // optional CrowdObject crowd = 20;
            case 20: {
                const limit = pushTemporaryLength(bb);
                message.crowd = _decodeCrowdObject(bb);
                bb.limit = limit;
                break;
            }
            // optional ScenarioObject scenario = 21;
            case 21: {
                const limit = pushTemporaryLength(bb);
                message.scenario = _decodeScenarioObject(bb);
                bb.limit = limit;
                break;
            }
            // optional AlgoObject algo = 22;
            case 22: {
                const limit = pushTemporaryLength(bb);
                message.algo = _decodeAlgoObject(bb);
                bb.limit = limit;
                break;
            }
            // optional EventObject event = 23;
            case 23: {
                const limit = pushTemporaryLength(bb);
                message.event = _decodeEventObject(bb);
                bb.limit = limit;
                break;
            }
            default:
                skipUnknownField(bb, tag & 7);
        }
    }
    return message;
}
export function encodeScenarioObject(message) {
    const bb = popByteBuffer();
    _encodeScenarioObject(message, bb);
    return toUint8Array(bb);
}
function _encodeScenarioObject(message, bb) {
    // optional ScenarioType type = 1;
    const $type = message.type;
    if ($type !== undefined) {
        writeVarint32(bb, 8);
        writeVarint32(bb, encodeScenarioType[$type]);
    }
}
export function decodeScenarioObject(binary) {
    return _decodeScenarioObject(wrapByteBuffer(binary));
}
function _decodeScenarioObject(bb) {
    const message = {};
    end_of_message: while (!isAtEnd(bb)) {
        const tag = readVarint32(bb);
        switch (tag >>> 3) {
            case 0:
                break end_of_message;
            // optional ScenarioType type = 1;
            case 1: {
                message.type = decodeScenarioType[readVarint32(bb)];
                break;
            }
            default:
                skipUnknownField(bb, tag & 7);
        }
    }
    return message;
}
export function encodeCrowdMovementObject(message) {
    const bb = popByteBuffer();
    _encodeCrowdMovementObject(message, bb);
    return toUint8Array(bb);
}
function _encodeCrowdMovementObject(message, bb) {
    // optional int32 roi_id = 1;
    const $roi_id = message.roi_id;
    if ($roi_id !== undefined) {
        writeVarint32(bb, 8);
        writeVarint64(bb, intToLong($roi_id));
    }
    // optional BoundingPoly roi = 2;
    const $roi = message.roi;
    if ($roi !== undefined) {
        writeVarint32(bb, 18);
        const nested = popByteBuffer();
        _encodeBoundingPoly($roi, nested);
        writeVarint32(bb, nested.limit);
        writeByteBuffer(bb, nested);
        pushByteBuffer(nested);
    }
    // optional CrowdDirection direction = 3;
    const $direction = message.direction;
    if ($direction !== undefined) {
        writeVarint32(bb, 24);
        writeVarint32(bb, encodeCrowdDirection[$direction]);
    }
}
export function decodeCrowdMovementObject(binary) {
    return _decodeCrowdMovementObject(wrapByteBuffer(binary));
}
function _decodeCrowdMovementObject(bb) {
    const message = {};
    end_of_message: while (!isAtEnd(bb)) {
        const tag = readVarint32(bb);
        switch (tag >>> 3) {
            case 0:
                break end_of_message;
            // optional int32 roi_id = 1;
            case 1: {
                message.roi_id = readVarint32(bb);
                break;
            }
            // optional BoundingPoly roi = 2;
            case 2: {
                const limit = pushTemporaryLength(bb);
                message.roi = _decodeBoundingPoly(bb);
                bb.limit = limit;
                break;
            }
            // optional CrowdDirection direction = 3;
            case 3: {
                message.direction = decodeCrowdDirection[readVarint32(bb)];
                break;
            }
            default:
                skipUnknownField(bb, tag & 7);
        }
    }
    return message;
}
export function encodeCrowdSpeedObject(message) {
    const bb = popByteBuffer();
    _encodeCrowdSpeedObject(message, bb);
    return toUint8Array(bb);
}
function _encodeCrowdSpeedObject(message, bb) {
    // optional int32 roi_id = 1;
    const $roi_id = message.roi_id;
    if ($roi_id !== undefined) {
        writeVarint32(bb, 8);
        writeVarint64(bb, intToLong($roi_id));
    }
    // optional BoundingPoly roi = 2;
    const $roi = message.roi;
    if ($roi !== undefined) {
        writeVarint32(bb, 18);
        const nested = popByteBuffer();
        _encodeBoundingPoly($roi, nested);
        writeVarint32(bb, nested.limit);
        writeByteBuffer(bb, nested);
        pushByteBuffer(nested);
    }
    // optional float speed = 3;
    const $speed = message.speed;
    if ($speed !== undefined) {
        writeVarint32(bb, 29);
        writeFloat(bb, $speed);
    }
}
export function decodeCrowdSpeedObject(binary) {
    return _decodeCrowdSpeedObject(wrapByteBuffer(binary));
}
function _decodeCrowdSpeedObject(bb) {
    const message = {};
    end_of_message: while (!isAtEnd(bb)) {
        const tag = readVarint32(bb);
        switch (tag >>> 3) {
            case 0:
                break end_of_message;
            // optional int32 roi_id = 1;
            case 1: {
                message.roi_id = readVarint32(bb);
                break;
            }
            // optional BoundingPoly roi = 2;
            case 2: {
                const limit = pushTemporaryLength(bb);
                message.roi = _decodeBoundingPoly(bb);
                bb.limit = limit;
                break;
            }
            // optional float speed = 3;
            case 3: {
                message.speed = readFloat(bb);
                break;
            }
            default:
                skipUnknownField(bb, tag & 7);
        }
    }
    return message;
}
export function encodeHeadTargetInfo(message) {
    const bb = popByteBuffer();
    _encodeHeadTargetInfo(message, bb);
    return toUint8Array(bb);
}
function _encodeHeadTargetInfo(message, bb) {
    // optional Vector coordinate = 1;
    const $coordinate = message.coordinate;
    if ($coordinate !== undefined) {
        writeVarint32(bb, 10);
        const nested = popByteBuffer();
        _encodeVector($coordinate, nested);
        writeVarint32(bb, nested.limit);
        writeByteBuffer(bb, nested);
        pushByteBuffer(nested);
    }
    // optional BoundingPoly rectangle = 2;
    const $rectangle = message.rectangle;
    if ($rectangle !== undefined) {
        writeVarint32(bb, 18);
        const nested = popByteBuffer();
        _encodeBoundingPoly($rectangle, nested);
        writeVarint32(bb, nested.limit);
        writeByteBuffer(bb, nested);
        pushByteBuffer(nested);
    }
}
export function decodeHeadTargetInfo(binary) {
    return _decodeHeadTargetInfo(wrapByteBuffer(binary));
}
function _decodeHeadTargetInfo(bb) {
    const message = {};
    end_of_message: while (!isAtEnd(bb)) {
        const tag = readVarint32(bb);
        switch (tag >>> 3) {
            case 0:
                break end_of_message;
            // optional Vector coordinate = 1;
            case 1: {
                const limit = pushTemporaryLength(bb);
                message.coordinate = _decodeVector(bb);
                bb.limit = limit;
                break;
            }
            // optional BoundingPoly rectangle = 2;
            case 2: {
                const limit = pushTemporaryLength(bb);
                message.rectangle = _decodeBoundingPoly(bb);
                bb.limit = limit;
                break;
            }
            default:
                skipUnknownField(bb, tag & 7);
        }
    }
    return message;
}
export function encodeCrowdCrossLineResult(message) {
    const bb = popByteBuffer();
    _encodeCrowdCrossLineResult(message, bb);
    return toUint8Array(bb);
}
function _encodeCrowdCrossLineResult(message, bb) {
    // optional int32 roi_id = 1;
    const $roi_id = message.roi_id;
    if ($roi_id !== undefined) {
        writeVarint32(bb, 8);
        writeVarint64(bb, intToLong($roi_id));
    }
    // repeated LineVertex cross_lines = 2;
    const array$cross_lines = message.cross_lines;
    if (array$cross_lines !== undefined) {
        for (const value of array$cross_lines) {
            writeVarint32(bb, 18);
            const nested = popByteBuffer();
            _encodeLineVertex(value, nested);
            writeVarint32(bb, nested.limit);
            writeByteBuffer(bb, nested);
            pushByteBuffer(nested);
        }
    }
    // repeated Vertex directions = 3;
    const array$directions = message.directions;
    if (array$directions !== undefined) {
        for (const value of array$directions) {
            writeVarint32(bb, 26);
            const nested = popByteBuffer();
            _encodeVertex(value, nested);
            writeVarint32(bb, nested.limit);
            writeByteBuffer(bb, nested);
            pushByteBuffer(nested);
        }
    }
    // optional int32 in_count = 4;
    const $in_count = message.in_count;
    if ($in_count !== undefined) {
        writeVarint32(bb, 32);
        writeVarint64(bb, intToLong($in_count));
    }
    // optional int32 out_count = 5;
    const $out_count = message.out_count;
    if ($out_count !== undefined) {
        writeVarint32(bb, 40);
        writeVarint64(bb, intToLong($out_count));
    }
    // repeated HeadTargetInfo head_targets = 6;
    const array$head_targets = message.head_targets;
    if (array$head_targets !== undefined) {
        for (const value of array$head_targets) {
            writeVarint32(bb, 50);
            const nested = popByteBuffer();
            _encodeHeadTargetInfo(value, nested);
            writeVarint32(bb, nested.limit);
            writeByteBuffer(bb, nested);
            pushByteBuffer(nested);
        }
    }
}
export function decodeCrowdCrossLineResult(binary) {
    return _decodeCrowdCrossLineResult(wrapByteBuffer(binary));
}
function _decodeCrowdCrossLineResult(bb) {
    const message = {};
    end_of_message: while (!isAtEnd(bb)) {
        const tag = readVarint32(bb);
        switch (tag >>> 3) {
            case 0:
                break end_of_message;
            // optional int32 roi_id = 1;
            case 1: {
                message.roi_id = readVarint32(bb);
                break;
            }
            // repeated LineVertex cross_lines = 2;
            case 2: {
                const limit = pushTemporaryLength(bb);
                const values = message.cross_lines || (message.cross_lines = []);
                values.push(_decodeLineVertex(bb));
                bb.limit = limit;
                break;
            }
            // repeated Vertex directions = 3;
            case 3: {
                const limit = pushTemporaryLength(bb);
                const values = message.directions || (message.directions = []);
                values.push(_decodeVertex(bb));
                bb.limit = limit;
                break;
            }
            // optional int32 in_count = 4;
            case 4: {
                message.in_count = readVarint32(bb);
                break;
            }
            // optional int32 out_count = 5;
            case 5: {
                message.out_count = readVarint32(bb);
                break;
            }
            // repeated HeadTargetInfo head_targets = 6;
            case 6: {
                const limit = pushTemporaryLength(bb);
                const values = message.head_targets || (message.head_targets = []);
                values.push(_decodeHeadTargetInfo(bb));
                bb.limit = limit;
                break;
            }
            default:
                skipUnknownField(bb, tag & 7);
        }
    }
    return message;
}
export function encodeCrowdAreaResult(message) {
    const bb = popByteBuffer();
    _encodeCrowdAreaResult(message, bb);
    return toUint8Array(bb);
}
function _encodeCrowdAreaResult(message, bb) {
    // optional int32 roi_id = 1;
    const $roi_id = message.roi_id;
    if ($roi_id !== undefined) {
        writeVarint32(bb, 8);
        writeVarint64(bb, intToLong($roi_id));
    }
    // optional BoundingPoly roi = 2;
    const $roi = message.roi;
    if ($roi !== undefined) {
        writeVarint32(bb, 18);
        const nested = popByteBuffer();
        _encodeBoundingPoly($roi, nested);
        writeVarint32(bb, nested.limit);
        writeByteBuffer(bb, nested);
        pushByteBuffer(nested);
    }
    // repeated HeadTargetInfo head_targets = 3;
    const array$head_targets = message.head_targets;
    if (array$head_targets !== undefined) {
        for (const value of array$head_targets) {
            writeVarint32(bb, 26);
            const nested = popByteBuffer();
            _encodeHeadTargetInfo(value, nested);
            writeVarint32(bb, nested.limit);
            writeByteBuffer(bb, nested);
            pushByteBuffer(nested);
        }
    }
}
export function decodeCrowdAreaResult(binary) {
    return _decodeCrowdAreaResult(wrapByteBuffer(binary));
}
function _decodeCrowdAreaResult(bb) {
    const message = {};
    end_of_message: while (!isAtEnd(bb)) {
        const tag = readVarint32(bb);
        switch (tag >>> 3) {
            case 0:
                break end_of_message;
            // optional int32 roi_id = 1;
            case 1: {
                message.roi_id = readVarint32(bb);
                break;
            }
            // optional BoundingPoly roi = 2;
            case 2: {
                const limit = pushTemporaryLength(bb);
                message.roi = _decodeBoundingPoly(bb);
                bb.limit = limit;
                break;
            }
            // repeated HeadTargetInfo head_targets = 3;
            case 3: {
                const limit = pushTemporaryLength(bb);
                const values = message.head_targets || (message.head_targets = []);
                values.push(_decodeHeadTargetInfo(bb));
                bb.limit = limit;
                break;
            }
            default:
                skipUnknownField(bb, tag & 7);
        }
    }
    return message;
}
export function encodeCrowdQueuePersonnelDetail(message) {
    const bb = popByteBuffer();
    _encodeCrowdQueuePersonnelDetail(message, bb);
    return toUint8Array(bb);
}
function _encodeCrowdQueuePersonnelDetail(message, bb) {
    // optional int64 queue_time = 1;
    const $queue_time = message.queue_time;
    if ($queue_time !== undefined) {
        writeVarint32(bb, 8);
        writeVarint64(bb, $queue_time);
    }
    // optional HeadTargetInfo person_info = 2;
    const $person_info = message.person_info;
    if ($person_info !== undefined) {
        writeVarint32(bb, 18);
        const nested = popByteBuffer();
        _encodeHeadTargetInfo($person_info, nested);
        writeVarint32(bb, nested.limit);
        writeByteBuffer(bb, nested);
        pushByteBuffer(nested);
    }
}
export function decodeCrowdQueuePersonnelDetail(binary) {
    return _decodeCrowdQueuePersonnelDetail(wrapByteBuffer(binary));
}
function _decodeCrowdQueuePersonnelDetail(bb) {
    const message = {};
    end_of_message: while (!isAtEnd(bb)) {
        const tag = readVarint32(bb);
        switch (tag >>> 3) {
            case 0:
                break end_of_message;
            // optional int64 queue_time = 1;
            case 1: {
                message.queue_time = readVarint64(bb, /* unsigned */ false);
                break;
            }
            // optional HeadTargetInfo person_info = 2;
            case 2: {
                const limit = pushTemporaryLength(bb);
                message.person_info = _decodeHeadTargetInfo(bb);
                bb.limit = limit;
                break;
            }
            default:
                skipUnknownField(bb, tag & 7);
        }
    }
    return message;
}
export function encodeCrowdQueueResult(message) {
    const bb = popByteBuffer();
    _encodeCrowdQueueResult(message, bb);
    return toUint8Array(bb);
}
function _encodeCrowdQueueResult(message, bb) {
    // optional int32 roi_id = 1;
    const $roi_id = message.roi_id;
    if ($roi_id !== undefined) {
        writeVarint32(bb, 8);
        writeVarint64(bb, intToLong($roi_id));
    }
    // optional BoundingPoly roi = 2;
    const $roi = message.roi;
    if ($roi !== undefined) {
        writeVarint32(bb, 18);
        const nested = popByteBuffer();
        _encodeBoundingPoly($roi, nested);
        writeVarint32(bb, nested.limit);
        writeByteBuffer(bb, nested);
        pushByteBuffer(nested);
    }
    // optional LineVertex queue_line = 3;
    const $queue_line = message.queue_line;
    if ($queue_line !== undefined) {
        writeVarint32(bb, 26);
        const nested = popByteBuffer();
        _encodeLineVertex($queue_line, nested);
        writeVarint32(bb, nested.limit);
        writeByteBuffer(bb, nested);
        pushByteBuffer(nested);
    }
    // repeated CrowdQueuePersonnelDetail queue_personnels = 4;
    const array$queue_personnels = message.queue_personnels;
    if (array$queue_personnels !== undefined) {
        for (const value of array$queue_personnels) {
            writeVarint32(bb, 34);
            const nested = popByteBuffer();
            _encodeCrowdQueuePersonnelDetail(value, nested);
            writeVarint32(bb, nested.limit);
            writeByteBuffer(bb, nested);
            pushByteBuffer(nested);
        }
    }
}
export function decodeCrowdQueueResult(binary) {
    return _decodeCrowdQueueResult(wrapByteBuffer(binary));
}
function _decodeCrowdQueueResult(bb) {
    const message = {};
    end_of_message: while (!isAtEnd(bb)) {
        const tag = readVarint32(bb);
        switch (tag >>> 3) {
            case 0:
                break end_of_message;
            // optional int32 roi_id = 1;
            case 1: {
                message.roi_id = readVarint32(bb);
                break;
            }
            // optional BoundingPoly roi = 2;
            case 2: {
                const limit = pushTemporaryLength(bb);
                message.roi = _decodeBoundingPoly(bb);
                bb.limit = limit;
                break;
            }
            // optional LineVertex queue_line = 3;
            case 3: {
                const limit = pushTemporaryLength(bb);
                message.queue_line = _decodeLineVertex(bb);
                bb.limit = limit;
                break;
            }
            // repeated CrowdQueuePersonnelDetail queue_personnels = 4;
            case 4: {
                const limit = pushTemporaryLength(bb);
                const values = message.queue_personnels || (message.queue_personnels = []);
                values.push(_decodeCrowdQueuePersonnelDetail(bb));
                bb.limit = limit;
                break;
            }
            default:
                skipUnknownField(bb, tag & 7);
        }
    }
    return message;
}
export function encodeCrowdObject(message) {
    const bb = popByteBuffer();
    _encodeCrowdObject(message, bb);
    return toUint8Array(bb);
}
function _encodeCrowdObject(message, bb) {
    // optional int64 quantity = 1;
    const $quantity = message.quantity;
    if ($quantity !== undefined) {
        writeVarint32(bb, 8);
        writeVarint64(bb, $quantity);
    }
    // optional Size density_size = 2;
    const $density_size = message.density_size;
    if ($density_size !== undefined) {
        writeVarint32(bb, 18);
        const nested = popByteBuffer();
        _encodeSize($density_size, nested);
        writeVarint32(bb, nested.limit);
        writeByteBuffer(bb, nested);
        pushByteBuffer(nested);
    }
    // optional bytes density = 3;
    const $density = message.density;
    if ($density !== undefined) {
        writeVarint32(bb, 26);
        writeVarint32(bb, $density.length), writeBytes(bb, $density);
    }
    // repeated CrowdCrossLineResult cross_line_objects = 4;
    const array$cross_line_objects = message.cross_line_objects;
    if (array$cross_line_objects !== undefined) {
        for (const value of array$cross_line_objects) {
            writeVarint32(bb, 34);
            const nested = popByteBuffer();
            _encodeCrowdCrossLineResult(value, nested);
            writeVarint32(bb, nested.limit);
            writeByteBuffer(bb, nested);
            pushByteBuffer(nested);
        }
    }
    // repeated CrowdAreaResult area_objects = 8;
    const array$area_objects = message.area_objects;
    if (array$area_objects !== undefined) {
        for (const value of array$area_objects) {
            writeVarint32(bb, 66);
            const nested = popByteBuffer();
            _encodeCrowdAreaResult(value, nested);
            writeVarint32(bb, nested.limit);
            writeByteBuffer(bb, nested);
            pushByteBuffer(nested);
        }
    }
    // repeated CrowdQueueResult queue_objects = 9;
    const array$queue_objects = message.queue_objects;
    if (array$queue_objects !== undefined) {
        for (const value of array$queue_objects) {
            writeVarint32(bb, 74);
            const nested = popByteBuffer();
            _encodeCrowdQueueResult(value, nested);
            writeVarint32(bb, nested.limit);
            writeByteBuffer(bb, nested);
            pushByteBuffer(nested);
        }
    }
}
export function decodeCrowdObject(binary) {
    return _decodeCrowdObject(wrapByteBuffer(binary));
}
function _decodeCrowdObject(bb) {
    const message = {};
    end_of_message: while (!isAtEnd(bb)) {
        const tag = readVarint32(bb);
        switch (tag >>> 3) {
            case 0:
                break end_of_message;
            // optional int64 quantity = 1;
            case 1: {
                message.quantity = readVarint64(bb, /* unsigned */ false);
                break;
            }
            // optional Size density_size = 2;
            case 2: {
                const limit = pushTemporaryLength(bb);
                message.density_size = _decodeSize(bb);
                bb.limit = limit;
                break;
            }
            // optional bytes density = 3;
            case 3: {
                message.density = readBytes(bb, readVarint32(bb));
                break;
            }
            // repeated CrowdCrossLineResult cross_line_objects = 4;
            case 4: {
                const limit = pushTemporaryLength(bb);
                const values = message.cross_line_objects || (message.cross_line_objects = []);
                values.push(_decodeCrowdCrossLineResult(bb));
                bb.limit = limit;
                break;
            }
            // repeated CrowdAreaResult area_objects = 8;
            case 8: {
                const limit = pushTemporaryLength(bb);
                const values = message.area_objects || (message.area_objects = []);
                values.push(_decodeCrowdAreaResult(bb));
                bb.limit = limit;
                break;
            }
            // repeated CrowdQueueResult queue_objects = 9;
            case 9: {
                const limit = pushTemporaryLength(bb);
                const values = message.queue_objects || (message.queue_objects = []);
                values.push(_decodeCrowdQueueResult(bb));
                bb.limit = limit;
                break;
            }
            default:
                skipUnknownField(bb, tag & 7);
        }
    }
    return message;
}
export function encodeAlgoObject(message) {
    const bb = popByteBuffer();
    _encodeAlgoObject(message, bb);
    return toUint8Array(bb);
}
function _encodeAlgoObject(message, bb) {
    // optional string app_name = 1;
    const $app_name = message.app_name;
    if ($app_name !== undefined) {
        writeVarint32(bb, 10);
        writeString(bb, $app_name);
    }
    // optional int32 app_version = 2;
    const $app_version = message.app_version;
    if ($app_version !== undefined) {
        writeVarint32(bb, 16);
        writeVarint64(bb, intToLong($app_version));
    }
    // optional string object_type = 3;
    const $object_type = message.object_type;
    if ($object_type !== undefined) {
        writeVarint32(bb, 26);
        writeString(bb, $object_type);
    }
    // optional int32 object_version = 4;
    const $object_version = message.object_version;
    if ($object_version !== undefined) {
        writeVarint32(bb, 32);
        writeVarint64(bb, intToLong($object_version));
    }
    // optional string data = 5;
    const $data = message.data;
    if ($data !== undefined) {
        writeVarint32(bb, 42);
        writeString(bb, $data);
    }
}
export function decodeAlgoObject(binary) {
    return _decodeAlgoObject(wrapByteBuffer(binary));
}
function _decodeAlgoObject(bb) {
    const message = {};
    end_of_message: while (!isAtEnd(bb)) {
        const tag = readVarint32(bb);
        switch (tag >>> 3) {
            case 0:
                break end_of_message;
            // optional string app_name = 1;
            case 1: {
                message.app_name = readString(bb, readVarint32(bb));
                break;
            }
            // optional int32 app_version = 2;
            case 2: {
                message.app_version = readVarint32(bb);
                break;
            }
            // optional string object_type = 3;
            case 3: {
                message.object_type = readString(bb, readVarint32(bb));
                break;
            }
            // optional int32 object_version = 4;
            case 4: {
                message.object_version = readVarint32(bb);
                break;
            }
            // optional string data = 5;
            case 5: {
                message.data = readString(bb, readVarint32(bb));
                break;
            }
            default:
                skipUnknownField(bb, tag & 7);
        }
    }
    return message;
}
export function encodePreviewInfo(message) {
    const bb = popByteBuffer();
    _encodePreviewInfo(message, bb);
    return toUint8Array(bb);
}
function _encodePreviewInfo(message, bb) {
    // optional int64 timestamp = 1;
    const $timestamp = message.timestamp;
    if ($timestamp !== undefined) {
        writeVarint32(bb, 8);
        writeVarint64(bb, $timestamp);
    }
    // repeated PreviewObject objects = 2;
    const array$objects = message.objects;
    if (array$objects !== undefined) {
        for (const value of array$objects) {
            writeVarint32(bb, 18);
            const nested = popByteBuffer();
            _encodePreviewObject(value, nested);
            writeVarint32(bb, nested.limit);
            writeByteBuffer(bb, nested);
            pushByteBuffer(nested);
        }
    }
    // repeated EventRule rules = 3;
    const array$rules = message.rules;
    if (array$rules !== undefined) {
        for (const value of array$rules) {
            writeVarint32(bb, 26);
            const nested = popByteBuffer();
            _encodeEventRule(value, nested);
            writeVarint32(bb, nested.limit);
            writeByteBuffer(bb, nested);
            pushByteBuffer(nested);
        }
    }
}
export function decodePreviewInfo(binary) {
    return _decodePreviewInfo(wrapByteBuffer(binary));
}
function _decodePreviewInfo(bb) {
    const message = {};
    end_of_message: while (!isAtEnd(bb)) {
        const tag = readVarint32(bb);
        switch (tag >>> 3) {
            case 0:
                break end_of_message;
            // optional int64 timestamp = 1;
            case 1: {
                message.timestamp = readVarint64(bb, /* unsigned */ false);
                break;
            }
            // repeated PreviewObject objects = 2;
            case 2: {
                const limit = pushTemporaryLength(bb);
                const values = message.objects || (message.objects = []);
                values.push(_decodePreviewObject(bb));
                bb.limit = limit;
                break;
            }
            // repeated EventRule rules = 3;
            case 3: {
                const limit = pushTemporaryLength(bb);
                const values = message.rules || (message.rules = []);
                values.push(_decodeEventRule(bb));
                bb.limit = limit;
                break;
            }
            default:
                skipUnknownField(bb, tag & 7);
        }
    }
    return message;
}
function pushTemporaryLength(bb) {
    const length = readVarint32(bb);
    const limit = bb.limit;
    bb.limit = bb.offset + length;
    return limit;
}
function skipUnknownField(bb, type) {
    switch (type) {
        case 0:
            while (readByte(bb) & 0x80) { }
            break;
        case 2:
            skip(bb, readVarint32(bb));
            break;
        case 5:
            skip(bb, 4);
            break;
        case 1:
            skip(bb, 8);
            break;
        default: throw new Error('Unimplemented type: ' + type);
    }
}
function stringToLong(value) {
    return {
        low: value.charCodeAt(0) | (value.charCodeAt(1) << 16),
        high: value.charCodeAt(2) | (value.charCodeAt(3) << 16),
        unsigned: false,
    };
}
function longToString(value) {
    const low = value.low;
    const high = value.high;
    return String.fromCharCode(low & 0xFFFF, low >>> 16, high & 0xFFFF, high >>> 16);
}
// The code below was modified from https://github.com/protobufjs/bytebuffer.js
// which is under the Apache License 2.0.
const f32 = new Float32Array(1);
const f32_u8 = new Uint8Array(f32.buffer);
const f64 = new Float64Array(1);
const f64_u8 = new Uint8Array(f64.buffer);
function intToLong(value) {
    value |= 0;
    return {
        low: value,
        high: value >> 31,
        unsigned: value >= 0,
    };
}
const bbStack = [];
function popByteBuffer() {
    const bb = bbStack.pop();
    if (!bb)
        return { bytes: new Uint8Array(64), offset: 0, limit: 0 };
    bb.offset = bb.limit = 0;
    return bb;
}
function pushByteBuffer(bb) {
    bbStack.push(bb);
}
function wrapByteBuffer(bytes) {
    return { bytes, offset: 0, limit: bytes.length };
}
function toUint8Array(bb) {
    const bytes = bb.bytes;
    const limit = bb.limit;
    return bytes.length === limit ? bytes : bytes.subarray(0, limit);
}
function skip(bb, offset) {
    if (bb.offset + offset > bb.limit) {
        throw new Error('Skip past limit');
    }
    bb.offset += offset;
}
function isAtEnd(bb) {
    return bb.offset >= bb.limit;
}
function grow(bb, count) {
    const bytes = bb.bytes;
    const offset = bb.offset;
    const limit = bb.limit;
    const finalOffset = offset + count;
    if (finalOffset > bytes.length) {
        const newBytes = new Uint8Array(finalOffset * 2);
        newBytes.set(bytes);
        bb.bytes = newBytes;
    }
    bb.offset = finalOffset;
    if (finalOffset > limit) {
        bb.limit = finalOffset;
    }
    return offset;
}
function advance(bb, count) {
    const offset = bb.offset;
    if (offset + count > bb.limit) {
        throw new Error('Read past limit');
    }
    bb.offset += count;
    return offset;
}
function readBytes(bb, count) {
    const offset = advance(bb, count);
    return bb.bytes.subarray(offset, offset + count);
}
function writeBytes(bb, buffer) {
    const offset = grow(bb, buffer.length);
    bb.bytes.set(buffer, offset);
}
function readString(bb, count) {
    // Sadly a hand-coded UTF8 decoder is much faster than subarray+TextDecoder in V8
    const offset = advance(bb, count);
    const fromCharCode = String.fromCharCode;
    const bytes = bb.bytes;
    const invalid = '\uFFFD';
    let text = '';
    for (let i = 0; i < count; i++) {
        const c1 = bytes[i + offset];
        let c2;
        let c3;
        let c4;
        let c;
        // 1 byte
        if ((c1 & 0x80) === 0) {
            text += fromCharCode(c1);
        }
        // 2 bytes
        else if ((c1 & 0xE0) === 0xC0) {
            if (i + 1 >= count)
                text += invalid;
            else {
                c2 = bytes[i + offset + 1];
                if ((c2 & 0xC0) !== 0x80)
                    text += invalid;
                else {
                    c = ((c1 & 0x1F) << 6) | (c2 & 0x3F);
                    if (c < 0x80)
                        text += invalid;
                    else {
                        text += fromCharCode(c);
                        i++;
                    }
                }
            }
        }
        // 3 bytes
        else if ((c1 & 0xF0) == 0xE0) {
            if (i + 2 >= count)
                text += invalid;
            else {
                c2 = bytes[i + offset + 1];
                c3 = bytes[i + offset + 2];
                if (((c2 | (c3 << 8)) & 0xC0C0) !== 0x8080)
                    text += invalid;
                else {
                    c = ((c1 & 0x0F) << 12) | ((c2 & 0x3F) << 6) | (c3 & 0x3F);
                    if (c < 0x0800 || (c >= 0xD800 && c <= 0xDFFF))
                        text += invalid;
                    else {
                        text += fromCharCode(c);
                        i += 2;
                    }
                }
            }
        }
        // 4 bytes
        else if ((c1 & 0xF8) == 0xF0) {
            if (i + 3 >= count)
                text += invalid;
            else {
                c2 = bytes[i + offset + 1];
                c3 = bytes[i + offset + 2];
                c4 = bytes[i + offset + 3];
                if (((c2 | (c3 << 8) | (c4 << 16)) & 0xC0C0C0) !== 0x808080)
                    text += invalid;
                else {
                    c = ((c1 & 0x07) << 0x12) | ((c2 & 0x3F) << 0x0C) | ((c3 & 0x3F) << 0x06) | (c4 & 0x3F);
                    if (c < 0x10000 || c > 0x10FFFF)
                        text += invalid;
                    else {
                        c -= 0x10000;
                        text += fromCharCode((c >> 10) + 0xD800, (c & 0x3FF) + 0xDC00);
                        i += 3;
                    }
                }
            }
        }
        else
            text += invalid;
    }
    return text;
}
function writeString(bb, text) {
    // Sadly a hand-coded UTF8 encoder is much faster than TextEncoder+set in V8
    const n = text.length;
    let byteCount = 0;
    // Write the byte count first
    for (let i = 0; i < n; i++) {
        let c = text.charCodeAt(i);
        if (c >= 0xD800 && c <= 0xDBFF && i + 1 < n) {
            c = (c << 10) + text.charCodeAt(++i) - 0x35FDC00;
        }
        byteCount += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    writeVarint32(bb, byteCount);
    let offset = grow(bb, byteCount);
    const bytes = bb.bytes;
    // Then write the bytes
    for (let i = 0; i < n; i++) {
        let c = text.charCodeAt(i);
        if (c >= 0xD800 && c <= 0xDBFF && i + 1 < n) {
            c = (c << 10) + text.charCodeAt(++i) - 0x35FDC00;
        }
        if (c < 0x80) {
            bytes[offset++] = c;
        }
        else {
            if (c < 0x800) {
                bytes[offset++] = ((c >> 6) & 0x1F) | 0xC0;
            }
            else {
                if (c < 0x10000) {
                    bytes[offset++] = ((c >> 12) & 0x0F) | 0xE0;
                }
                else {
                    bytes[offset++] = ((c >> 18) & 0x07) | 0xF0;
                    bytes[offset++] = ((c >> 12) & 0x3F) | 0x80;
                }
                bytes[offset++] = ((c >> 6) & 0x3F) | 0x80;
            }
            bytes[offset++] = (c & 0x3F) | 0x80;
        }
    }
}
function writeByteBuffer(bb, buffer) {
    const offset = grow(bb, buffer.limit);
    const from = bb.bytes;
    const to = buffer.bytes;
    // This for loop is much faster than subarray+set on V8
    for (let i = 0, n = buffer.limit; i < n; i++) {
        from[i + offset] = to[i];
    }
}
function readByte(bb) {
    return bb.bytes[advance(bb, 1)];
}
function writeByte(bb, value) {
    const offset = grow(bb, 1);
    bb.bytes[offset] = value;
}
function readFloat(bb) {
    let offset = advance(bb, 4);
    const bytes = bb.bytes;
    // Manual copying is much faster than subarray+set in V8
    f32_u8[0] = bytes[offset++];
    f32_u8[1] = bytes[offset++];
    f32_u8[2] = bytes[offset++];
    f32_u8[3] = bytes[offset++];
    return f32[0];
}
function writeFloat(bb, value) {
    let offset = grow(bb, 4);
    const bytes = bb.bytes;
    f32[0] = value;
    // Manual copying is much faster than subarray+set in V8
    bytes[offset++] = f32_u8[0];
    bytes[offset++] = f32_u8[1];
    bytes[offset++] = f32_u8[2];
    bytes[offset++] = f32_u8[3];
}
function readDouble(bb) {
    let offset = advance(bb, 8);
    const bytes = bb.bytes;
    // Manual copying is much faster than subarray+set in V8
    f64_u8[0] = bytes[offset++];
    f64_u8[1] = bytes[offset++];
    f64_u8[2] = bytes[offset++];
    f64_u8[3] = bytes[offset++];
    f64_u8[4] = bytes[offset++];
    f64_u8[5] = bytes[offset++];
    f64_u8[6] = bytes[offset++];
    f64_u8[7] = bytes[offset++];
    return f64[0];
}
function writeDouble(bb, value) {
    let offset = grow(bb, 8);
    const bytes = bb.bytes;
    f64[0] = value;
    // Manual copying is much faster than subarray+set in V8
    bytes[offset++] = f64_u8[0];
    bytes[offset++] = f64_u8[1];
    bytes[offset++] = f64_u8[2];
    bytes[offset++] = f64_u8[3];
    bytes[offset++] = f64_u8[4];
    bytes[offset++] = f64_u8[5];
    bytes[offset++] = f64_u8[6];
    bytes[offset++] = f64_u8[7];
}
function readInt32(bb) {
    const offset = advance(bb, 4);
    const bytes = bb.bytes;
    return (bytes[offset] |
        (bytes[offset + 1] << 8) |
        (bytes[offset + 2] << 16) |
        (bytes[offset + 3] << 24));
}
function writeInt32(bb, value) {
    const offset = grow(bb, 4);
    const bytes = bb.bytes;
    bytes[offset] = value;
    bytes[offset + 1] = value >> 8;
    bytes[offset + 2] = value >> 16;
    bytes[offset + 3] = value >> 24;
}
function readInt64(bb, unsigned) {
    return {
        low: readInt32(bb),
        high: readInt32(bb),
        unsigned,
    };
}
function writeInt64(bb, value) {
    writeInt32(bb, value.low);
    writeInt32(bb, value.high);
}
function readVarint32(bb) {
    let c = 0;
    let value = 0;
    let b;
    do {
        b = readByte(bb);
        if (c < 32)
            value |= (b & 0x7F) << c;
        c += 7;
    } while (b & 0x80);
    return value;
}
function writeVarint32(bb, value) {
    value >>>= 0;
    while (value >= 0x80) {
        writeByte(bb, (value & 0x7f) | 0x80);
        value >>>= 7;
    }
    writeByte(bb, value);
}
function readVarint64(bb, unsigned) {
    let part0 = 0;
    let part1 = 0;
    let part2 = 0;
    let b;
    b = readByte(bb);
    part0 = (b & 0x7F);
    if (b & 0x80) {
        b = readByte(bb);
        part0 |= (b & 0x7F) << 7;
        if (b & 0x80) {
            b = readByte(bb);
            part0 |= (b & 0x7F) << 14;
            if (b & 0x80) {
                b = readByte(bb);
                part0 |= (b & 0x7F) << 21;
                if (b & 0x80) {
                    b = readByte(bb);
                    part1 = (b & 0x7F);
                    if (b & 0x80) {
                        b = readByte(bb);
                        part1 |= (b & 0x7F) << 7;
                        if (b & 0x80) {
                            b = readByte(bb);
                            part1 |= (b & 0x7F) << 14;
                            if (b & 0x80) {
                                b = readByte(bb);
                                part1 |= (b & 0x7F) << 21;
                                if (b & 0x80) {
                                    b = readByte(bb);
                                    part2 = (b & 0x7F);
                                    if (b & 0x80) {
                                        b = readByte(bb);
                                        part2 |= (b & 0x7F) << 7;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    return {
        low: part0 | (part1 << 28),
        high: (part1 >>> 4) | (part2 << 24),
        unsigned,
    };
}
function writeVarint64(bb, value) {
    const part0 = value.low >>> 0;
    const part1 = ((value.low >>> 28) | (value.high << 4)) >>> 0;
    const part2 = value.high >>> 24;
    // ref: src/google/protobuf/io/coded_stream.cc
    const size = part2 === 0
        ? part1 === 0
            ? part0 < 1 << 14
                ? part0 < 1 << 7 ? 1 : 2
                : part0 < 1 << 21 ? 3 : 4
            : part1 < 1 << 14
                ? part1 < 1 << 7 ? 5 : 6
                : part1 < 1 << 21 ? 7 : 8
        : part2 < 1 << 7 ? 9 : 10;
    const offset = grow(bb, size);
    const bytes = bb.bytes;
    switch (size) {
        /* eslint-disable no-fallthrough */
        case 10: bytes[offset + 9] = (part2 >>> 7) & 0x01;
        case 9: bytes[offset + 8] = size !== 9 ? part2 | 0x80 : part2 & 0x7F;
        case 8: bytes[offset + 7] = size !== 8 ? (part1 >>> 21) | 0x80 : (part1 >>> 21) & 0x7F;
        case 7: bytes[offset + 6] = size !== 7 ? (part1 >>> 14) | 0x80 : (part1 >>> 14) & 0x7F;
        case 6: bytes[offset + 5] = size !== 6 ? (part1 >>> 7) | 0x80 : (part1 >>> 7) & 0x7F;
        case 5: bytes[offset + 4] = size !== 5 ? part1 | 0x80 : part1 & 0x7F;
        case 4: bytes[offset + 3] = size !== 4 ? (part0 >>> 21) | 0x80 : (part0 >>> 21) & 0x7F;
        case 3: bytes[offset + 2] = size !== 3 ? (part0 >>> 14) | 0x80 : (part0 >>> 14) & 0x7F;
        case 2: bytes[offset + 1] = size !== 2 ? (part0 >>> 7) | 0x80 : (part0 >>> 7) & 0x7F;
        case 1: bytes[offset] = size !== 1 ? part0 | 0x80 : part0 & 0x7F;
        /* eslint-enable no-fallthrough */
    }
}
function readVarint32ZigZag(bb) {
    const value = readVarint32(bb);
    // ref: src/google/protobuf/wire_format_lite.h
    return (value >>> 1) ^ -(value & 1);
}
function writeVarint32ZigZag(bb, value) {
    // ref: src/google/protobuf/wire_format_lite.h
    writeVarint32(bb, (value << 1) ^ (value >> 31));
}
function readVarint64ZigZag(bb) {
    const value = readVarint64(bb, /* unsigned */ false);
    const low = value.low;
    const high = value.high;
    const flip = -(low & 1);
    // ref: src/google/protobuf/wire_format_lite.h
    return {
        low: ((low >>> 1) | (high << 31)) ^ flip,
        high: (high >>> 1) ^ flip,
        unsigned: false,
    };
}
function writeVarint64ZigZag(bb, value) {
    const low = value.low;
    const high = value.high;
    const flip = high >> 31;
    // ref: src/google/protobuf/wire_format_lite.h
    writeVarint64(bb, {
        low: (low << 1) ^ flip,
        high: ((high << 1) | (low >>> 31)) ^ flip,
        unsigned: false,
    });
}
